import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable react/no-unknown-property, react/self-closing-comp, react/no-unused-prop-types */
export default function MenuIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='lucide lucide-panel-left'
      data-lov-id='src/components/ui/sidebar.tsx:279:6'
      data-lov-name='PanelLeft'
      data-component-path='src/components/ui/sidebar.tsx'
      data-component-line='279'
      data-component-file='sidebar.tsx'
      data-component-name='PanelLeft'
      data-component-content='%7B%7D'
    >
      <rect width='18' height='18' x='3' y='3' rx='2'></rect>
      <path d='M9 3v18'></path>
    </svg>
  );
}

MenuIcon.propTypes = {
  className: PropTypes.string,
};
